import { AgGridReact, AgGridReactProps } from '@ag-grid-community/react';
import { Flex } from '@chakra-ui/react';
import { GridReadyEvent } from '@ag-grid-community/core';
import { LegacyRef, useCallback } from 'react';
import { ActiveRowCountLabel } from './active-row-count';
import { ActiveRowCountHeader, useGridActiveRowCount } from './ActiveRowCount';

export const Grid = function <TData = unknown>(
    props: AgGridReactProps<TData> & { gridRef?: LegacyRef<AgGridReact<TData>>; countLabel?: ActiveRowCountLabel },
) {
    const { gridRef, onGridReady, countLabel, ...rest } = props;
    const { count, attach } = useGridActiveRowCount();
    const isAutoHeight = rest.domLayout === 'autoHeight';

    const handleGridReady = useCallback(
        (event: GridReadyEvent<TData>) => {
            onGridReady?.(event);
            attach(event.api);
        },
        [onGridReady, attach],
    );

    return (
        <Flex
            flexDirection="column"
            className="ag-theme-quartz"
            css={{
                '--ag-background-color': { _dark: 'colors.musa.dark.500' },
                '--ag-header-background-color': { _dark: 'colors.musa.dark.500' },
                '--ag-foreground-color': { _dark: 'musa.dark.label' },
                '--ag-header-foreground-color': { _dark: 'musa.dark.label' },
                '--ag-border-color': { _dark: 'colors.musa.dark.border' },
            }}
            h={isAutoHeight ? undefined : '100%'}>
            <ActiveRowCountHeader count={count} label={countLabel} />
            <Flex flex={isAutoHeight ? undefined : '1'} minH={isAutoHeight ? undefined : '0'} flexDirection="column">
                <AgGridReact {...rest} ref={gridRef} onGridReady={handleGridReady} />
            </Flex>
        </Flex>
    );
};
